"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _style = require("./style");
var _Avatar = _interopRequireDefault(require("../Avatar/Avatar"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const SidebarListItem = _ref => {
  let {
    title,
    icon,
    onItemClick,
    badges,
    badgeIcon,
    selected,
    user,
    className
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_style.ItemStyled, {
    onClick: () => onItemClick(),
    hasUser: user,
    selected: selected,
    className: className
  }, icon && /*#__PURE__*/_react.default.createElement(_style.IconContainer, {
    selected: selected
  }, icon), /*#__PURE__*/_react.default.createElement(_style.LabelContainer, null, user ? ( /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Avatar.default, {
    src: user.profileImageUrl,
    fallbackUrl: user.fallbackUrl,
    alt: user.name,
    size: "small",
    type: "social",
    network: user.network
  }), /*#__PURE__*/_react.default.createElement(_style.NameHandleWrapper, null, /*#__PURE__*/_react.default.createElement(_style.LabelStyled, {
    type: "label",
    title: title,
    hasUser: user,
    selected: selected
  }, user.name), /*#__PURE__*/_react.default.createElement(_style.Handle, {
    title: user.handle,
    selected: selected
  }, user.handle)))) : ( /*#__PURE__*/_react.default.createElement(_style.LabelStyled, {
    type: "label",
    title: title,
    selected: selected
  }, title))), !badgeIcon && badges && /*#__PURE__*/_react.default.createElement(_style.Badge, {
    selected: selected
  }, badges), badgeIcon && ( /*#__PURE__*/_react.default.createElement(_style.BadgeIconContainer, {
    selected: selected
  }, badgeIcon)));
};
SidebarListItem.propTypes = {
  id: _propTypes.default.string,
  className: _propTypes.default.string,
  title: _propTypes.default.string.isRequired,
  icon: _propTypes.default.node,
  onItemClick: _propTypes.default.func.isRequired,
  badges: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  badgeIcon: _propTypes.default.node,
  selected: _propTypes.default.bool,
  user: _propTypes.default.shape({
    id: _propTypes.default.string,
    name: _propTypes.default.string,
    handle: _propTypes.default.string,
    profileImageUrl: _propTypes.default.string,
    fallbackUrl: _propTypes.default.string,
    network: _propTypes.default.oneOf(['facebook', 'twitter', 'instagram', 'linkedin', 'google', 'pinterest', 'tiktok', 'googlebusiness', 'startPage', 'mastodon', 'youtube', 'threads'])
  })
};
SidebarListItem.defaultProps = {
  id: '',
  icon: null,
  badgeIcon: null,
  badges: null,
  selected: null,
  user: null,
  className: null
};
var _default = exports.default = SidebarListItem;